<template>
  <b-modal
    id="dispatch_alarm_modal"
    ref="dispatchAlarmModal"
    onclose="onClose"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header
    body-class="p-0"
    size="lg"
  >
    <p class="mb-0 h3 p-1">{{ $t("alarm.dispatchAlarm") }}</p>
    <hr class="my-0">
    <b-row class="p-1">
      <b-col cols="12" class="text-capitalize mb-1">
        <label class="text-capitalize">
          {{ $t("pacom.typeAlarm") }}
        </label>
        <v-select
          label="description"
          v-model="alarm.type"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="typeAlarms"
          :clearable="false"
          :reduce="(val) => val.type"
          input-id="id_type_alarm"
          @search="onSearch"
        />
      </b-col>
      <b-col cols="12" class="text-capitalize mb-1">
        <label class="text-capitalize">{{ $tc("unit.title", 1) }}</label>
        <facilities-select-paginated
          v-model="alarm.facility"
          :multiple="false"
          @option:selected="onFacilitySelect"
        />
      </b-col>
      <b-col cols="12" class="map">
        <units-map-slot @marker:click="onMarkerClick" :data="mapData"/>
      </b-col>
    </b-row>

    <template #modal-footer="{ close }">
      <b-button
        size="sm"
        :disabled="loading"
        @click="createAlarm()"
      >
        {{ $t("alarm.dispatch") }}
      </b-button>
      <b-button
        variant="primary"
        size="sm"
        :disabled="loading"
        @click="close()"
      >
        {{ $t("close") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {BButton, BModal} from "bootstrap-vue";
import vSelect from "vue-select";
import {getCurrentInstance, onMounted, ref} from "@vue/composition-api";
import store from "@/store";
import axios from "@/libs/axios";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import {useUtils as useI18nUtils} from "@core/libs/i18n";
import {useToast} from "vue-toastification/composition";
import UnitsMapSlot
  from "@/views/components/GridView/layouts/slots/UnitsMapSlot/index.vue";
import {debounce} from "lodash";
import FacilitiesSelectPaginated from "@/components/FacilitiesSelectPaginated.vue";

export default {
  components: {
    FacilitiesSelectPaginated,
    UnitsMapSlot,
    BModal,
    vSelect,
  },
  setup(_, {emit}) {
    const vm = getCurrentInstance().proxy;
    const onShow = () => {
    };
    const resetDataModal = () => {
    };

    const dispatchAlarmModal = ref();
    const loading = ref(false);
    const typeAlarms = ref([]);
    const facilities = ref([]);
    const alarm = ref({
      facility: null,
      type: null
    });
    const {t} = useI18nUtils();
    const toast = useToast();
    const mapData = ref({
      zoom: 13,
      centerAuto: true
    });

    const onClose = () => {
      alarm.value = {
        facility: {},
        type: null
      }
    }

    const createAlarm = async () => {
      if (alarm.value.type === null || alarm.value.type === undefined || !alarm.value.facility) {
        return
      }
      loading.value = true;

      try {

        const alarmData = {
          id_router: alarm.value.facility.id_router,
          type: alarm.value.type,
        };
        const {data} = await axios.post('v1/services/alarms/dispatch', alarmData);
        toast({
          component: ToastificationContent,
          props: {
            title: data.message,
            icon: "CheckIcon",
            variant: "success",
          }
        });
      } catch (error) {
        const {message} = error.response;
        toast({
          component: ToastificationContent,
          props: {
            title: message,
            icon: "AlertTriangleIcon",
            variant: "danger",
          }
        });
      } finally {
        loading.value = false;
        dispatchAlarmModal.value.hide();
      }
    };

    const getLists = async () => {
      let {data: dataTypeAlarm} = await store.dispatch("type_alarm/getAll", {max: 100});
      let {data: dataFacilities} = await store.dispatch('unit/getAll', {
        with: 'router:id,id_tenant',
        max: 10000
      });

      typeAlarms.value = dataTypeAlarm
      facilities.value = dataFacilities.map((facility) => {
        return {
          id: facility.id,
          description: facility.description,
          id_router: facility.id_router,
        };
      });
    };

    const onSearch = debounce(async (query, loading) => {
      loading(true);
      let {data: dataTypeAlarm} = await store.dispatch("type_alarm/getAll", {max: 100, q: query});
      typeAlarms.value = dataTypeAlarm;
      loading(false);
    }, 500);

    const onClearFiltersClick = (close) => {
      emit("clear");
    };

    const onMarkerClick = ({data}) => {
      alarm.value.facility = data;
    };

    const onFacilitySelect = (data) => {
      alarm.value.facility = data;
      mapData.value = {id_unit: data.value};
    };

    onMounted(async () => {
      await getLists();
    });

    return {
      onShow,
      onClose,
      resetDataModal,
      onClearFiltersClick,
      onMarkerClick,
      onFacilitySelect,
      createAlarm,
      dispatchAlarmModal,
      loading,
      typeAlarms,
      facilities,
      alarm,
      mapData,
      onSearch,
    };
  },
};
</script>

<style lang="scss">
#dispatch_alarm_modal___BV_modal_body_ {
  height: 600px;

  .map {
    min-height: 380px;
  }
}
</style>
